import { Component, Inject, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { IImprestVendor } from '../../models/imprest-vendor.model';
import { ImprestService } from '../../services/imprest.service';
import { debounceTime, Subject } from 'rxjs';

@Component({
  selector: 'app-manage-imprest-vendors',
  standalone: true,
  imports: [MatDialogModule, ReactiveFormsModule],
  templateUrl: './manage-imprest-vendors.component.html',
  styleUrl: './manage-imprest-vendors.component.scss'
})
export class ManageImprestVendorsComponent implements OnDestroy {
  form: FormGroup;
  data: IImprestVendor;
  loading: boolean = true;
  searchPayee = new Subject<string>();
  searchVendor = new Subject<string>();

  constructor(@Inject(MAT_DIALOG_DATA) public imprestVendor: IImprestVendor, 
  private fb: FormBuilder,
  private imprestService: ImprestService,
  public dialogRef: MatDialogRef<ManageImprestVendorsComponent>) {
    this.data = Object.assign({}, imprestVendor);
    this.form = this.fb.group({
      currency: [''],
      vendor: ['', [Validators.required, Validators.pattern('^[0-9]*$')]],
      payee: ['', [Validators.required, Validators.pattern('^[0-9]*$')]]
    });

    this.form.patchValue(this.data);

    this.searchPayee
      .pipe(debounceTime(300))
      .subscribe((id) => {
        this.imprestService.getAddressBookAlphaName(id).subscribe({
          next: data => {
              this.data['payeeName'] = data;
              this.form.controls['payee'].setErrors(null);
              this.loading = false;
            },
          error: () => {
            this.data['payeeName'] = 'Not found';
            this.form.controls['payee'].setErrors({ 'incorrect': true });
            this.loading = false;
          }
        });
      });

    this.searchVendor
      .pipe(debounceTime(300))
      .subscribe((id) => {
        this.imprestService.getAddressBookAlphaName(id).subscribe({
          next: data => {
              this.data['vendorName'] = data;
              this.form.controls['vendor'].setErrors(null);
              this.loading = false;
            },
          error: () => {
            this.data['vendorName'] = 'Not found';
            this.form.controls['vendor'].setErrors({ 'incorrect': true });
            this.loading = false;
          }
        });
      });
  }

  submit(): void {
    if (this.form.valid && !this.loading) {
      this.data.currency = this.form.value.currency;
      this.data.vendor = this.form.value.vendor;
      this.data.payee = this.form.value.payee;
      this.imprestService.updateImprestVendor(this.data).subscribe({
        next: () => {
          this.dialogRef.close();
        },
        error: () => {
          this.dialogRef.close();
        }
      });
    }
  }

  getAddressBook(id: string, controlName: string): void {
    this.loading = true;
    if (controlName === 'payee') {
      this.searchPayee.next(id);
    } else {
      this.searchVendor.next(id);
    }
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  ngOnDestroy() {
    this.searchPayee.complete();
    this.searchVendor.complete();
  }
}